import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { RequestProvider } from '../../../context/RequestContext'
import { AirconRepair } from '../../../components/index/service-category/aircon-service/AirconRepair'
import { Services } from '../../../components/index/service/Services'
import { airconCostCalculation } from '../../../js/aircon-cost'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { BottomButtons } from '@/index/service-category/aircon-service/BottomButtons'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    let lat = 1.3521
    let lng = 103.8198
    const { month, year } = getArticleDateTime();
    const modifiedDate = reviewedIso(CONTENT_REVIEWED);
    const airconBlogs = blogsMaster['hvac-services'].blogArray;

    const countryName = "Singapore"
    const allRequestCategorySettings = await getRequestJSON(countryName)
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const currencyCd = "SGD"

    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        standardServicing,
        countryName,
        currencyCd
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings
    const standardServicing = props.standardServicing
    const currencyCd = props.currencyCd
    const requestType = 'Aircon Services'
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ isQuickBook, setIsQuickBook ] = useState(false)

  return (
    <>
      <Head>
        <title>Aircon Printed Circuit Board (PCB) Repair & Replacement Cost</title>
        <meta charSet="utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Aircon indoor unit PCB replacement can cost anywhere between $350 to $450, whereas, the condenser unit PCB replacement can cost between $480 to $600."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Aircon Printed Circuit Board (PCB) Repair & Replacement Cost`}/>
        <meta property="og:description" content="Aircon indoor unit PCB replacement can cost anywhere between $350 to $450, whereas, the condenser unit PCB replacement can cost between $480 to $600." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-18T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-printed-circuit-board.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-printed-circuit-board.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb"/>
        <meta name="twitter:title" content={`Aircon Printed Circuit Board (PCB) Repair & Replacement Cost`}/> 
        <meta name="twitter:description" content="Aircon indoor unit PCB replacement can cost anywhere between $350 to $450, whereas, the condenser unit PCB replacement can cost between $480 to $600."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb"/>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb"},"headline":"Aircon Printed Circuit Board (PCB) Repair & Replacement Cost","description":"Aircon indoor unit PCB replacement can cost anywhere between $350 to $450, whereas, the condenser unit PCB replacement can cost between $480 to $600.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-printed-circuit-board.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-18T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"}},{"@type":"ListItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore","name":"Aircon Servicing Singapore","url":"https://www.stringssg.com/sg/aircon-servicing-singapore"}},{"@type":"ListItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb","name":"Aircon PCB Replacement","url":"https://www.stringssg.com/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb"}}]}]}`
          }}
        />
        </Head>
        <div>
            <RequestProvider>
                <section id="aircon-pcb-repair-replacement" className='relative'>
                    <AirconRepair 
                        setRequestForm={setRequestForm} 
                        setIsQuickBook={setIsQuickBook} 
                        title={"Aircon Printed Circuit Board (PCB) Repair & Replacement Cost"} 
                        problem={"Replace Faulty Aircon PCB for [brand name]"}
                        heroImage="blog/living/aircon-printed-circuit-board.jpg"
                    />
                </section>
                {!requestForm &&
                    <BottomButtons countryName={countryName}/>
                }
                {requestForm && 
                    <Services
                        requestType={requestType}
                        requestCategorySettings={requestCategorySettings}
                        setRequestForm={setRequestForm}
                        isQuickBook={isQuickBook}
                        isCustomBook={false}
                        asSheet
                    />
                }
            </RequestProvider>
            <div className='max-w-5xl mx-auto py-10 px-2 leading-8'>
                <div className='py-2 space-y-5'>
                    <div className='space-y-2'>
                        <h2 className='font-bold text-xl uppercase'>What is a Printed Circuit Board (PCB)?</h2>
                        <p className=''>
                            An aircon PCB (Printed Circuit Board) refers to the control or circuit board in an air conditioning unit that controls various functions of the system. 
                            It is responsible for receiving signals from the thermostat, processing these signals, and communicating with the various components of the air conditioning 
                            unit to maintain the desired temperature and other settings.
                        </p>
                        <p>
                            The aircon PCB contains various components, including microprocessors, sensors, relays, and other electronic components. It can be programmed with various 
                            settings and functions, depending on the specific model of the air conditioning unit.
                        </p>
                        <p>
                            If there is a problem with the aircon PCB, it can affect the overall performance of the air conditioning system. In such cases, a trained technician may need to diagnose the issue and repair or replace the faulty PCB to restore proper operation of the air conditioning unit.
                        </p>
                    </div>  
                    <div className='space-y-2'>
                        <h3 className='font-bold text-xl'>Indoor Aircon Unit PCB</h3>
                        <p className=''>
                            An aircon indoor unit PCB (Printed Circuit Board) refers to the circuit board that is located inside the indoor unit of an air conditioning system. This PCB is responsible for 
                            controlling the various functions of the indoor unit, such as the fan speed, air flow direction, and other settings.
                        </p>
                    </div> 
                    <div className='space-y-2'>
                        <h3 className='font-bold text-xl'>Outdoor Aircon Condenser PCB</h3>
                        <p className=''>
                            An aircon condenser PCB (Printed Circuit Board) refers to the control board or circuit board that is located inside the condenser unit of an air conditioning system. 
                            The condenser unit is the outdoor component of the air conditioning system that houses the compressor, fan, and other important components.
                        <br/>
                            The aircon condenser PCB is responsible for controlling the various functions of the condenser unit, such as the compressor, fan motor, and other parts. 
                            It receives signals from the thermostat and communicates with the indoor unit PCB to coordinate the overall operation of the air conditioning system.
                        </p>
                    </div> 
                    <div className='py-2 space-y-2'>
                        <h2 className='text-xl font-bold uppercase'>When to replace or repair an Aircon PCB?</h2>
                        <div className='space-y-2'>
                            <p className=''>
                                Whether to repair or replace an aircon PCB depends on several factors, including the age of the unit, the extent of the damage, and the cost of 
                                repair versus replacement. Here are some general guidelines to consider:
                            </p>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>1. Age of the unit</h3>
                                <p>
                                    If the air conditioning unit is relatively new and still under warranty, it may be more beneficial to have the PCB repaired rather than replaced. 
                                    However, if the unit is older, it may be more cost-effective to replace the PCB or even the entire unit.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>2. Extent of the damage</h3>
                                <p>
                                    If the damage to the PCB is minor, such as a blown fuse or faulty relay, it may be possible to repair the PCB. However, if the damage is severe, 
                                    such as a burnt-out board, it may be more beneficial to replace the PCB. However, a repair cost may be close to a complete replacement.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>3. Cost of repair versus replacement</h3>
                                <p>
                                    If your air conditioning system is under warranty then, the cheapest option is to get in touch with the dealer who can repair the PCB if it is still 
                                    repairable, otherwise is it more cost effective to replace the PCB with a new one, because the cost of repair can sometimes exceed the cost of replacement.
                                </p>
                            </div>                        
                        </div>
                    </div>
                    <div className='relative h-96'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/aircon-pcb-repair.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='technician installing the aircon unit'
                        />          
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-xl font-bold uppercase'>Why you should never repair a faulty aircon PCB?</h2>
                        <div className='space-y-2'>
                            <p className=''>
                                We always recommend to replace the damaged PCB over repairing it. Replacing the aircon PCB is always better than repairing it, especially if it is out of warranty,
                                for the following reasons:
                            </p>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>1. Efficiency</h3>
                                <p>
                                    A new PCB may be more efficient than a repaired PCB, leading to better performance and energy savings. This can result in lower electricity bills 
                                    and reduced wear and tear on the air conditioning unit.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>2. Reliability</h3>
                                <p>
                                    A new PCB is likely to be more reliable than a repaired PCB, as all the components are new and there is no risk of other parts failing shortly after the repair. This can provide peace of mind and reduce the likelihood of future breakdowns.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>3. Cost-effectiveness</h3>
                                <p>
                                    In many cases, the cost of repairing a PCB can be close to or even exceed the cost of replacing it. In such cases, it may be more cost-effective to 
                                    replace the PCB or even the entire unit, especially if the unit is old or outdated.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>4. Warranty</h3>
                                <p>
                                    A new PCB often comes with a warranty, which can provide added protection and coverage in case of any future issues.
                                </p>
                            </div>                        
                        </div>
                    </div>
                    <div className='py-2 space-y-2'>
                        <h2 className='text-xl font-bold uppercase'>Aircon Printed Circuit Board (PCB) Replacement Cost</h2>
                        <div className='space-y-5'>
                            <p>
                                Indoor unit PCB replacement can cost anywhere between $350 to $450, whereas, the condenser unit PCB replacement can cost between $480 to $600.
                            </p>
                            <p>
                                The cost of replacing an aircon Printed Circuit Board (PCB) can vary depending on several factors, such as the brand and model of the air conditioning unit, 
                                the complexity of the repair, and the cost of the replacement parts.
                            </p>
                            <p>
                                The replacement cost is inclusive of the parts, transportation and labor cost for replacing the PCB.
                            </p>
                            <p>
                                Usually the indoor unit PCB replacement cost is cheaper than the condenser unit PCB replacement.
                            </p>
                        </div>
                    </div>    
                    <h2 className='font-bold text-center uppercase'>Aircon PCB rates chart - 2024</h2>
                    <div className='overflow-x-auto'>
                        <table className='w-full border-collapse border border-slate-400'>
                            <thead className='text-orange-600 text-sm'>
                                <tr className=''>
                                    <th className='py-2 border border-slate-300'>Brand</th>
                                    <th className='py-2 border border-slate-300 break-all'>Indoor PCB</th>
                                    <th className='py-2 border border-slate-300 break-all'>Outdoor PCB</th>   
                                </tr>
                            </thead>                                
                            <tbody className='text-xs'>                     
                                <tr className=" table-row text-gray-500">
                                    <td className="py-1 text-center  text-orange-600 text-sm break-all border border-slate-300">
                                        <Link href="/sg/aircon-servicing-singapore/mitsubishi-electric">
                                                Mitsubishi
                                        </Link>
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $300 - $450
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $980 - $1200
                                    </td>
                                </tr>     
                                <tr className=" table-row text-gray-500">
                                    <td className="py-1 text-center  text-orange-600 text-sm break-all border border-slate-300">
                                        <Link href="/sg/aircon-servicing-singapore/daikin">
                                                Daikin
                                        </Link>
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $320 - $460
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $580 - $980
                                    </td>
                                </tr> 
                                <tr className=" table-row text-gray-500">
                                    <td className="py-1 text-center text-orange-600 text-sm break-all border border-slate-300">
                                        LG
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $280 - $380 
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $520 - $790
                                    </td>
                                </tr>        
                                <tr className=" table-row text-gray-500">
                                    <td className="py-1 text-center  text-orange-600 text-sm break-all border border-slate-300">
                                        <Link href="/sg/aircon-servicing-singapore/panasonic">
                                                Panasonic
                                        </Link>
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $260 - $390 
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $580 - $820
                                    </td>
                                </tr> 
                                <tr className=" table-row text-gray-500">
                                    <td className="py-1 text-center text-orange-600 text-sm break-all border border-slate-300">
                                        Fujitsu
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $260 - $380
                                    </td>
                                    <td className="py-1 text-center whitespace-pre-wrap border border-slate-300">
                                        $550 - $800
                                    </td>
                                </tr> 
                            </tbody>    
                        </table>
                    </div>               
                </div> 
                <div className='text-center py-10 relative'>
                    <div className='relative w-full h-120'>
                        <Image
                            src={s3Static + "blog/living/repairman-doing-air-conditioner-service.jpg"}
                            fill
                            style={{objectFit: 'cover', objectPosition: 'center'}}  
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Request for Aircon PCB Replacement - StringsSG'
                        />     
                    </div> 
                    <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                        <Link href="/sg/aircon-servicing-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl'>
                                Request for Aircon PCB Replacement
                        </Link>       
                    </div>  
                </div>
            </div>
            <BlogsList blogs={airconBlogs}/> 
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}